export const ADD_SONG_TO_PLAYLIST = 'ADD_SONG_TO_LIST';
export const GET_CUSTOMER_PLAYLIST = 'GET_PLAYLIST';
export const SET_PLAYLIST_INDEX = 'SET_PLAYLIST_INDEX';
export const SET_PLAYER_STATE = 'SET_PLAYER_STATE';
